import { createContext, useContext } from "react";
import type { XAdkSenderHandle } from "@/types";

/** DefaultLayout 与自定义 footer Sender 之间的内部协作信息。 */
export interface DefaultLayoutContextType {
  allowUpload?: boolean;
  registerSender?: (sender: XAdkSenderHandle | null) => void;
}

export const DefaultLayoutContext =
  createContext<DefaultLayoutContextType | null>(null);

export const useDefaultLayoutContext = () => useContext(DefaultLayoutContext);
